exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".background-image[data-v-b9455902]{bottom:0;left:0;right:0;top:0}", ""]);

